const findRelPath = path => image => image.node.relativePath === path;

class AssetModel {
  
  static getPathMap(imageEdges) {
      var dictionary = {};

      for(var i = 0; i < imageEdges.edges.length; i++) {
        dictionary[imageEdges.edges[i].node.relativePath] = imageEdges.edges[i].node.publicURL;
      }

      return dictionary;
  }
}

export default AssetModel;



// WEBPACK FOOTER //
// ./src/models/asset-model.js